import { useState, useEffect, useMemo } from "react";
import Swal from "sweetalert2";
import api from "services/api";
import { useAuth } from "hooks/useAuth";
import { useForm } from "react-hook-form";
import moment from "moment";
import { default as ReactSelect } from "react-select";
import makeAnimated from "react-select/animated";
import emailjs from "emailjs-com";
import { sortDESC, sortMesCompetencia, sortYear } from "utils/sort";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import { useLocation } from "react-router-dom";
import {
  FormControl,
  FormLabel,
  Textarea,
  Box,
  Select,
  useMediaQuery,
  Alert,
  AlertIcon,
  Text,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  Grid,
  Input,
  Divider,
  CircularProgress,
} from "@chakra-ui/react";
import { BiCommentDetail } from "react-icons/bi";
import { MdFileDownload } from "react-icons/md";
import { AiOutlineReload } from "react-icons/ai";
import { download } from "services/dowloadArquivo";
import { meses } from "utils/meses";
import { baseUrlLink } from "services/baseUrl";

interface Document {
  id: number;
  ano_competencia: number;
  nome_arquivo_s3: string;
  tipo_documento: any;
  operadora: any;
  entidade: any;
  contrato: any;
  mes_competencia: number;
  dt_vencimento: string;
  hist_validacao_docs: any;
  status_documento: any;
  updated_at: Date;
  valor: number;
  fl_envia_pos_limite: boolean;
  hash_arquivo: string;
  created_at: any;
  fl_validando_ext_bol_not: boolean;
  fl_pendencia_ext_bol_not: boolean;
}

function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

const Utilizacao = () => {
  let query = useQuery();
  const animatedComponents = makeAnimated();
  const [activeStep, setActiveStep] = useState(0);
  const [inputObervacaoEdit, setInputObservacaoEdit] = useState<any>("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [operadora, setOperadora] = useState<any[]>([]);
  const [usuariosContratos, setUsuariosContratos] = useState<any[]>([]);
  const [contratos, setContratos] = useState<any>([]);
  const [mobile] = useMediaQuery("(max-width: 624px)");
  const [notebook] = useMediaQuery("(max-width: 1366px)");
  const [click, setClick] = useState<string | null>(null);
  const [observacao, setObservacao] = useState<any>(null);
  const [isSending, setIsSending] = useState<boolean>(false);
  const [emailsUsers, setEmailsUsers] = useState<any>(null);
  const [statusContract, setStatusContract] = useState<any>("ativo");
  const [contractValue, setContractValue] = useState<any>(null);
  const [selectedOperadora, setSelectedOperadora] = useState<any>(
    query.get("op"),
  ); // Teste 26
  const [selectedContract, setSelectedContract] = useState<any>(
    query.get("contrato"),
  ); // Teste 81
  const [selectedYear] = useState<any>(query.get("ano"));
  const [linkExterno, setLinkExterno] = useState<any>(true);
  const [nameContrato, setNameContrato] = useState<any>(null);
  const [nameOperadora, setNameOperadora] = useState<any>(null);
  const [select, setSelect] = useState<boolean>(false);
  const [vigenciaContrato, setVigenciaContrato] = useState<any>(null);
  const [vigenciaContratoAtivo, setVigenciaContratoAtivo] = useState<any>(null);
  const [years, setYears] = useState<any>(null);
  const [yearValue, setYearValue] = useState<any>(null);
  const [documentId, setdocumentId] = useState<any>(null);
  const [documents, setDocuments] = useState<Document[]>([]);
  const [pageLoading, setPageLoading] = useState(false);
  const [pageLoadingOperadoras, setPageLoadingOperadoras] = useState(true);
  const { user } = useAuth();
  const { reset } = useForm({
    mode: "onBlur",
  });

  const yearMoment = moment().year(); //2021

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  async function getDocuments(selectedYear: any, contractId: any) {
    setPageLoading(true);
    setVigenciaContrato(null);
    setVigenciaContratoAtivo(null);
    setSelect(true);
    let documentsArray: any[] = [];
    setDocuments([]);

    if (selectedYear) {
      try {
        await api
          .get(`/documentos?contrato=${contractId || selectedContract}`)
          .then(async (res) => {
            const reduced: any[] = [];
            res.data
              .filter((op: any) => op.tipo_documento === 10)
              .forEach((doc: any) => {
                let duplicated =
                  reduced.findIndex((item: any) => {
                    return doc.ano_competencia === item.ano_competencia;
                  }) > -1;
                if (!duplicated) {
                  reduced.push(doc);
                }
              });
            let yearsArray: any[] = [];

            reduced
              .sort(sortYear)
              .map((year: any) => yearsArray.push(year?.ano_competencia));
            setYears(yearsArray);

            const docs = res.data.filter((op: any) => op.tipo_documento === 10);

            if (docs.length > 0) {
              if (yearMoment === parseInt(selectedYear)) {
                if (
                  reduced.find(
                    (doc: any) =>
                      doc.ano_competencia === parseInt(selectedYear),
                  ) !== undefined
                ) {
                  setYearValue(yearMoment);
                  docs.map(
                    (document: any) =>
                      document.ano_competencia === yearMoment &&
                      documentsArray.push(document),
                  );
                } else {
                  if (
                    docs.find(
                      (doc: any) =>
                        doc.ano_competencia === parseInt(selectedYear),
                    ) === undefined
                  ) {
                    docs.filter(
                      (document: any) =>
                        document.ano_competencia ===
                          parseInt(docs.sort(sortYear)[0].ano_competencia) &&
                        documentsArray.push(document),
                    );
                  } else {
                    docs.map(
                      (document: any) =>
                        document.ano_competencia !== yearMoment &&
                        documentsArray.push(document),
                    );
                  }
                }
              } else {
                docs.map(
                  (document: any) =>
                    document.ano_competencia === parseInt(selectedYear) &&
                    documentsArray.push(document),
                );
              }

              setDocuments(documentsArray.sort(sortMesCompetencia));
            } else {
              const contratoVigente = contratos.find(
                (contrato: { id: any }) =>
                  contrato.id === (contractId || selectedContract),
              );

              const dataVigente = moment(
                `${contratoVigente?.ano_ini_vigenc_ext_bol_not}-${contratoVigente?.mes_ini_vigenc_ext_bol_not}`,
              );

              setVigenciaContratoAtivo(contratoVigente?.fl_ativo);

              setVigenciaContrato(dataVigente.format("MM/YYYY"));
            }
          });
      } catch (err) {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Erro ao listar os documentos",
          showConfirmButton: true,
          confirmButtonText: `Ok`,
        });
      }
    } else {
      setDocuments([]);
    }
    setPageLoading(false);
  }

  const excludedUtilizacao = async () => {
    Swal.fire({
      title:
        "Essa ação excluirá os arquivos atuais permitindo que o usuário da pessoa jurídica inclua novos arquivos, deseja continuar?",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsSending(true);

        const documentData = {
          status_documento: 13,
          id_arq_nota: null,
          nm_arq_nota: null,
          hash_arq_nota: null,
          id_arq_boleto: null,
          nm_arq_boleto: null,
          hash_arq_boleto: null,
        };

        await api
          .put(`/documentos/${documentId}`, documentData)
          .then(async (res) => {
            const newDocument = res.data[0];
            const historyData = {
              documento: res.data[0].id,
              users_permissions_user: user?.id,
              status_documento: 13,
              valor: res.data[0].valor,
              observacao: inputObervacaoEdit,
              dt_vencimento: res.data[0].dt_vencimento,
              id_arq_nota: observacao.id_arq_nota,
              nm_arq_nota: observacao.nm_arq_nota,
              hash_arq_nota: observacao.hash_arq_nota,
              id_arquivo: observacao.id_arquivo,
              nome_arquivo: observacao.nome_arquivo,
              hash_arquivo: observacao.hash_arquivo,
              id_arq_boleto: observacao.id_arq_boleto,
              nm_arq_boleto: observacao.nm_arq_boleto,
              hash_arq_boleto: observacao.hash_arq_boleto,
            };

            const templateParams = {
              link: `${baseUrlLink}portal/operadoras/utilizacao?op=${res.data[0].operadora.id}&contrato=${res.data[0].contrato.id}&ano=${res.data[0].ano_competencia}`,
              emailEmpresa: emailsUsers,
              assunto: "Reenvio do arquivo de utilização",
              conteudo: `Olá ${nameOperadora}, os arquivos da utilização do mês ${observacao.mes_competencia}/${observacao.ano_competencia},
              )} foram excluídos. Favor incluir novos arquivos assim que possível.`,
            };

            try {
              await emailjs
                .send(
                  // @ts-ignore
                  process.env.REACT_APP_SERVICE_ID,
                  process.env.REACT_APP_TEMPLATE_ID_NOTIFICACAO_PJ,
                  templateParams,
                  process.env.REACT_APP_USER_ID,
                )
                .then((res) => {
                  console.log("EmailJS Ok!");
                });
            } catch (e) {
              console.log(e);
            }

            await api
              .post("/hist-validacao-docs", historyData)
              .then((res) => {
                const arrayDoc = documents.filter(
                  (doc) => doc.id !== documentId,
                );
                setDocuments(
                  [
                    ...arrayDoc,
                    {
                      ...newDocument,
                      hist_validacao_docs: [
                        ...newDocument.hist_validacao_docs,
                        res.data,
                      ],
                    },
                  ].sort(sortMesCompetencia),
                );

                setClick(null);
                setdocumentId(null);
                setObservacao(null);
                setInputObservacaoEdit(null);
                setActiveStep(0);

                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Arquivos excluídos com sucesso",
                  showConfirmButton: false,
                  timer: 3000,
                }).then(() => {
                  onClose();
                });
              })
              .catch((error) => {
                console.log("erro: ", error);
                onClose();
                Swal.fire({
                  icon: "warning",
                  title:
                    "Erro ao cadastrar o histórico do arquivo! Entre em contato com o administrador do sistema",
                  showConfirmButton: true,
                  confirmButtonText: `Ok`,
                });
              });
          })
          .catch((error) => {
            console.log("erro: ", error);
            onClose();
            Swal.fire({
              icon: "warning",
              title:
                "Erro ao atualizar status! Entre em contato com o administrador do sistema",
              showConfirmButton: true,
              confirmButtonText: `Ok`,
            });
          });

        setIsSending(false);
      }
    });
  };

  useEffect(() => {
    async function getOperadoras() {
      try {
        const response = await api.get("/operadoras?_sort=id:DESC");
        const operadorasWithContracts = response.data.filter((ent: any) =>
          ent.contratoes.find((cont: any) => cont.fl_sinistralidade),
        );

        if (
          selectedOperadora &&
          selectedContract &&
          selectedYear &&
          linkExterno
        ) {
          const ent = response.data.filter(
            (ent: any) => ent.id === parseInt(selectedOperadora),
          );

          setStatusContract("ativo");
          setNameOperadora(ent[0]?.nm_operadora);
          setDocuments([]);

          let arrayContracts: any[] = [];

          ent[0]?.contratoes.map(
            (doc: any) => doc.fl_sinistralidade && arrayContracts.push(doc),
          );

          setContratos(arrayContracts);
          setNameContrato(
            ent[0].contratoes
              .filter((ent: any) => ent.fl_sinistralidade)
              .filter(
                (cont: any) => parseInt(cont.id) === parseInt(selectedContract),
              )[0]?.desc_contrato,
          );

          getDocuments(selectedYear, selectedContract);
          setLinkExterno(false);
        }
        setOperadora(operadorasWithContracts);
        setPageLoadingOperadoras(false);
      } catch (err) {
        console.log(err);
        setPageLoading(false);
        Swal.fire({
          icon: "error",
          title: "Erro ao listar as Pessoas Jurídicas",
          showConfirmButton: true,
          confirmButtonText: `Ok`,
        });
      }
    }

    async function getUsuariosContratos() {
      try {
        const response = await api.get("/usuarios-contratoes");
        setUsuariosContratos(response.data);
        if (selectedContract !== null) {
          setEmailsUsers(
            response.data
              .filter((user: any) =>
                user.contratoes.find(
                  (cont: any) => cont.id === parseInt(selectedContract),
                ),
              )
              .map((user: any) => user.users_permissions_user?.email)
              .join(", "),
          );
        }
      } catch (err) {
        console.log(err);
        setPageLoading(false);
      }
    }

    getOperadoras();
    getUsuariosContratos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOperadora]);

  const getContracts = (idOperator: any) => {
    setSelectedContract(null);
    setDocuments([]);
    const ent = operadora.filter((ent) => ent.id === parseInt(idOperator));

    let arrayContracts: any[] = [];

    ent[0]?.contratoes.map(
      (doc: any) => doc.fl_sinistralidade && arrayContracts.push(doc),
    );

    setContratos(arrayContracts);
  };

  const handleChangeSelectedOperadora = (selectedOption: any) => {
    setContractValue(null);
    getContracts(selectedOption.value);
    setSelectedOperadora(selectedOption.value);
    setStatusContract("ativo");
    setNameOperadora(selectedOption.label);
  };

  const handleChangeSelectedContract = (selectedOption: any) => {
    setContractValue(selectedOption.value);
    getDocuments(yearMoment, selectedOption.value);
    setSelectedContract(selectedOption.value);
    setEmailsUsers(
      usuariosContratos
        .filter((user) =>
          user.contratoes.find((cont: any) => cont.id === selectedOption.value),
        )
        .map((user) => user.users_permissions_user?.email)
        .join(", "),
    );
  };

  if (pageLoadingOperadoras) {
    return (
      <Box
        as="section"
        display="flex"
        w="100%"
        justifyContent="center"
        alignItems="center"
      >
        <CircularProgress isIndeterminate color="blue.200" />
      </Box>
    );
  }

  return (
    contratos && (
      <>
        <Box
          display="flex"
          flexDirection="column"
          width="100%"
          overflow="hidden"
          h={notebook ? "calc(100vh + 40px)" : "unset"}
          margin="30px"
          gridRowGap="15px"
          position="relative"
        >
          <Box
            display="flex"
            flexDirection={mobile ? "column" : "row"}
            gridGap="15px"
            width="100%"
            height="max-content"
            maxWidth="500px"
            padding="12px"
            backgroundColor="#fff"
            boxShadow="0px 3px 3px -2px rgb(0 0 0 / 20%),
    0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)"
          >
            {operadora.length > 0 ? (
              <FormControl>
                <FormLabel htmlFor="selectedOperadora">Operadora:</FormLabel>
                <ReactSelect
                  className="basic-single"
                  classNamePrefix="select"
                  closeMenuOnSelect={true}
                  isSearchable={true}
                  placeholder="Selecione uma pessoa jurídica"
                  noOptionsMessage={() => "-"}
                  onChange={handleChangeSelectedOperadora}
                  defaultValue={
                    selectedOperadora && {
                      value: selectedOperadora,
                      label: nameOperadora,
                    }
                  }
                  options={operadora.map((ent) => ({
                    value: ent.id,
                    label: ent.nm_operadora,
                  }))}
                  components={animatedComponents}
                />
              </FormControl>
            ) : (
              <Alert status="info">
                <AlertIcon />
                Nenhum dado cadastrado!
              </Alert>
            )}
          </Box>
          {contratos && selectedOperadora && (
            <>
              {contratos &&
                contratos.filter((doc: any) => !doc.fl_ativo).length > 0 && (
                  <Box
                    display="flex"
                    flexDirection={mobile ? "column" : "row"}
                    gridGap="15px"
                    width="100%"
                    height="max-content"
                    maxWidth="500px"
                    padding="12px"
                    backgroundColor="#fff"
                    boxShadow="0px 3px 3px -2px rgb(0 0 0 / 20%),
    0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)"
                  >
                    <FormControl>
                      <FormLabel htmlFor="ano">Status dos contratos:</FormLabel>
                      <Select
                        id="statusContrato"
                        name="statusContrato"
                        type="text"
                        onChange={(e: any) => {
                          setStatusContract(e.target.value);
                          setDocuments([]);
                          setSelect(false);
                        }}
                        value={statusContract}
                      >
                        <option key="1" value="ativo">
                          Ativos
                        </option>
                        <option key="2" value="inativo">
                          Inativos
                        </option>
                      </Select>
                    </FormControl>
                  </Box>
                )}
              <Box
                display="flex"
                flexDirection={mobile ? "column" : "row"}
                gridGap="15px"
                width="100%"
                height="max-content"
                maxWidth="500px"
                padding="12px"
                backgroundColor="#fff"
                boxShadow="0px 3px 3px -2px rgb(0 0 0 / 20%),
    0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)"
              >
                <FormControl>
                  <FormLabel htmlFor="contratos">
                    Contratos{" "}
                    {statusContract === "ativo" ? "ativos" : "inativos"}:
                  </FormLabel>
                  <ReactSelect
                    className="basic-single"
                    classNamePrefix="select"
                    closeMenuOnSelect={true}
                    isSearchable={true}
                    placeholder="Selecione um contrato"
                    noOptionsMessage={() => "-"}
                    onChange={handleChangeSelectedContract}
                    value={
                      selectedContract && {
                        contractValue,
                        label:
                          (contratos &&
                            contratos.find(
                              (el: any) => el.id === parseInt(contractValue),
                            )?.desc_contrato) ||
                          nameContrato,
                      }
                    }
                    defaultValue={
                      selectedContract && {
                        value: selectedContract,
                        label: nameContrato,
                      }
                    }
                    options={contratos
                      .filter((doc: any) =>
                        statusContract === "ativo"
                          ? doc.fl_ativo
                          : !doc.fl_ativo,
                      )
                      .map((contrato: { id: any; desc_contrato: any }) => ({
                        value: contrato.id,
                        label: contrato.desc_contrato,
                      }))}
                    components={animatedComponents}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel htmlFor="ano">Ano:</FormLabel>
                  <Select
                    id="ano"
                    name="ano"
                    type="text"
                    onChange={(e: any) => {
                      getDocuments(e.target.value, null);
                      setYearValue(e.target.value);
                    }}
                    value={yearValue}
                  >
                    {years &&
                      years.map((year: any) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                  </Select>
                </FormControl>
              </Box>
              {selectedContract && (
                <Button
                  position="absolute"
                  right="10px"
                  top={
                    contratos &&
                    contratos.filter((doc: any) => !doc.fl_ativo).length > 0
                      ? mobile
                        ? "410px"
                        : "275px"
                      : mobile
                      ? "300px"
                      : "175px"
                  }
                  margin="0 auto"
                  colorScheme="unset"
                  variant="solid"
                  padding="0"
                  color="#555"
                  cursor="pointer"
                  _hover={{
                    backgroundColor: "#e3e8f0",
                    color: "blue.600",
                  }}
                  onClick={() => getDocuments(yearMoment, selectedContract)}
                >
                  {pageLoading ? (
                    <CircularProgress
                      isIndeterminate
                      size="22"
                      color="blue.200"
                    />
                  ) : (
                    <AiOutlineReload size="25" />
                  )}
                </Button>
              )}
              {selectedContract && documents.length > 0 ? (
                <>
                  {pageLoading ? (
                    <Box
                      as="section"
                      display="flex"
                      w="100%"
                      height="300px"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <CircularProgress isIndeterminate color="blue.200" />
                    </Box>
                  ) : (
                    <>
                      <Box
                        display="flex"
                        marginTop={mobile ? "40px" : 0}
                        flexDirection="column"
                        overflow="auto"
                        width="100%"
                        height="max-content"
                        padding="15px"
                        backgroundColor="#fff"
                        boxShadow="0px 3px 3px -2px rgb(0 0 0 / 20%),
            0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)"
                      >
                        <Box
                          fontSize="17px"
                          display="grid"
                          gridTemplateColumns="110px 200px 150px 150px 96px 77px"
                          justifyContent="space-between"
                          padding="0 5px"
                          minWidth="960px"
                          alignItems="center"
                        >
                          <Text paddingLeft="5px">Mês</Text>
                          <Text>Status</Text>
                          <Text textAlign="center">Recebimento</Text>
                          <Text textAlign="center">Arquivos</Text>
                          <Text textAlign="center">Modificação</Text>
                          <Text textAlign="center">Histórico</Text>
                        </Box>
                        <Accordion allowToggle>
                          {documents &&
                            documents.length > 0 &&
                            documents.map((doc, i) => (
                              <AccordionItem
                                key={i}
                                border="none"
                                margin="5px 0"
                                minWidth="960px"
                                backgroundColor="#eee"
                                borderRadius="12px"
                                _hover={{ backgroundColor: "#e3e8f0" }}
                              >
                                <Box
                                  fontSize="16px"
                                  display="grid"
                                  gridTemplateColumns="110px 200px 150px 150px 96px 77px"
                                  minWidth="960px"
                                  justifyContent="space-between"
                                  padding="5px"
                                  alignItems="center"
                                >
                                  <Text paddingLeft="5px" fontSize="17px">
                                    {meses[doc.mes_competencia - 1]}
                                  </Text>

                                  <Alert
                                    padding="5px 5px 5px 0"
                                    backgroundColor="unset"
                                    status={
                                      doc.status_documento === 12 ||
                                      doc.status_documento.id === 12
                                        ? "success"
                                        : "warning"
                                    }
                                  >
                                    <AlertIcon />

                                    <Text>
                                      {doc.status_documento === 1 ||
                                      doc.status_documento.id === 1
                                        ? "Não enviado"
                                        : doc.status_documento === 12 ||
                                          doc.status_documento.id === 12
                                        ? "Enviado"
                                        : (doc.status_documento === 13 ||
                                            doc.status_documento.id === 13) &&
                                          "Arquivos excluídos. Aguardando reenvio"}
                                    </Text>
                                  </Alert>

                                  <Text textAlign="center">
                                    {moment(doc.dt_vencimento).format(
                                      "DD/MM/YYYY",
                                    )}
                                  </Text>

                                  {doc.status_documento === 12 ||
                                  doc.status_documento.id === 12 ? (
                                    <Text textAlign="center">
                                      <Button
                                        onClick={
                                          doc.status_documento === 12 ||
                                          doc.status_documento.id === 12
                                            ? () => {
                                                onOpen();
                                                setdocumentId(doc.id);
                                                setClick("editUtilizacao");
                                                setObservacao(doc);
                                              }
                                            : () => {}
                                        }
                                        margin="0 auto"
                                        colorScheme="unset"
                                        variant="solid"
                                        padding="0"
                                        color="green.600"
                                        cursor="pointer"
                                        _hover={{
                                          backgroundColor: "#cad8eb",
                                          color: "blue.600",
                                        }}
                                      >
                                        <MdFileDownload size="20px" />
                                      </Button>
                                    </Text>
                                  ) : (
                                    <Text textAlign="center">-</Text>
                                  )}

                                  {doc.status_documento === 1 ||
                                  doc.status_documento.id === 1 ? (
                                    <Text textAlign="center">-</Text>
                                  ) : (
                                    <Text textAlign="center">
                                      {moment(doc.updated_at).format(
                                        "DD/MM/YYYY",
                                      )}
                                    </Text>
                                  )}

                                  <AccordionButton
                                    margin="0 auto"
                                    justifyContent="center"
                                    width="40px"
                                    height="40px"
                                    padding="0"
                                    borderRadius="8px"
                                    _hover={{
                                      backgroundColor: "#cad8eb",
                                      color: "blue.600",
                                    }}
                                  >
                                    <AccordionIcon />
                                  </AccordionButton>
                                </Box>
                                <AccordionPanel
                                  padding="20px"
                                  borderTop="1px solid white"
                                >
                                  <Box display="flex">
                                    {doc?.hist_validacao_docs?.length > 0 ? (
                                      <>
                                        <Box
                                          width="100%"
                                          borderRadius="12px"
                                          margin="2px 0"
                                          padding="5px"
                                          height="max-content"
                                        >
                                          <Text
                                            width="max-content"
                                            margin="5px"
                                            fontSize="18px"
                                            fontWeight="500"
                                          >
                                            Histórico
                                          </Text>
                                          <Box
                                            fontSize="16px"
                                            display="grid"
                                            gridTemplateColumns="27% 26% 11% 11% 14% 11%"
                                            width="100%"
                                            padding="5px"
                                            alignItems="center"
                                          >
                                            <Text>Status</Text>
                                            <Text textAlign="center">
                                              Usuário
                                            </Text>
                                            <Text textAlign="center">
                                              Modificação
                                            </Text>
                                            <Text textAlign="center">Hora</Text>

                                            <Text textAlign="center">
                                              Arquivos
                                            </Text>

                                            <Text textAlign="center">
                                              Observação
                                            </Text>
                                          </Box>
                                          {doc.hist_validacao_docs
                                            .sort(sortDESC)
                                            .map((hist: any) => (
                                              <Box
                                                key={hist.id}
                                                borderTop="1px solid white"
                                                fontSize="16px"
                                                display="grid"
                                                gridTemplateColumns="27% 26% 11% 11% 14% 11%"
                                                width="100%"
                                                padding="5px"
                                                alignItems="center"
                                                // _hover={{
                                                //   backgroundColor: "#d5e1ea",
                                                // }}
                                              >
                                                <Alert
                                                  padding="5px"
                                                  backgroundColor="unset"
                                                  status={
                                                    hist.status_documento.id ===
                                                      12 ||
                                                    hist.status_documento === 12
                                                      ? "success"
                                                      : "warning"
                                                  }
                                                >
                                                  <AlertIcon />
                                                  {hist.status_documento.id ===
                                                    12 ||
                                                  hist.status_documento === 12
                                                    ? "Enviado"
                                                    : hist.status_documento
                                                        .id === 13 ||
                                                      hist.status_documento ===
                                                        13
                                                    ? "Arquivos excluídos. Aguardando reenvio"
                                                    : "Não enviado"}
                                                </Alert>
                                                <Text
                                                  textAlign="center"
                                                  fontSize="15px"
                                                >
                                                  {
                                                    hist.users_permissions_user
                                                      .nome
                                                  }
                                                </Text>
                                                <Text textAlign="center">
                                                  {moment(
                                                    hist.published_at,
                                                  ).format("DD/MM/YYYY")}
                                                </Text>
                                                <Text textAlign="center">
                                                  {moment(
                                                    hist.published_at,
                                                  ).format("HH:mm")}
                                                </Text>

                                                {hist.id_arq_nota ||
                                                hist.id_arq_boleto ? (
                                                  <Text textAlign="center">
                                                    <Button
                                                      onClick={() => {
                                                        onOpen();
                                                        setClick(
                                                          "downloadHist",
                                                        );
                                                        setObservacao(hist);
                                                      }}
                                                      colorScheme="unset"
                                                      variant="solid"
                                                      padding="0"
                                                      color="#555"
                                                      _hover={{
                                                        backgroundColor:
                                                          "#cad8eb",
                                                        color: "blue.600",
                                                      }}
                                                    >
                                                      <MdFileDownload size="22px" />
                                                    </Button>
                                                  </Text>
                                                ) : (
                                                  <Text textAlign="center">
                                                    -
                                                  </Text>
                                                )}

                                                {hist.observacao ? (
                                                  <Text textAlign="center">
                                                    <Button
                                                      onClick={() => {
                                                        onOpen();
                                                        setClick("observacao");
                                                        setObservacao(hist);
                                                      }}
                                                      colorScheme="unset"
                                                      variant="solid"
                                                      padding="0"
                                                      color="#555"
                                                      _hover={{
                                                        backgroundColor:
                                                          "#cad8eb",
                                                        color: "blue.600",
                                                      }}
                                                    >
                                                      <BiCommentDetail size="22px" />
                                                    </Button>
                                                  </Text>
                                                ) : (
                                                  <Text textAlign="center">
                                                    -
                                                  </Text>
                                                )}
                                              </Box>
                                            ))}
                                        </Box>
                                      </>
                                    ) : (
                                      <Text
                                        padding="5px 5px 0"
                                        fontSize="18px"
                                        fontWeight="bold"
                                      >
                                        Sem Histórico
                                      </Text>
                                    )}
                                  </Box>
                                </AccordionPanel>
                              </AccordionItem>
                            ))}
                        </Accordion>
                      </Box>

                      <Modal
                        scrollBehavior="inside"
                        isCentered
                        onClose={() => {
                          reset();
                          setClick(null);
                          setObservacao(null);
                          setActiveStep(0);
                          onClose();
                        }}
                        isOpen={isOpen}
                        motionPreset="slideInBottom"
                      >
                        <ModalOverlay />
                        <ModalContent>
                          {click && click === "editUtilizacao" ? (
                            <>
                              <ModalHeader>
                                <Alert
                                  padding="5px"
                                  backgroundColor="unset"
                                  status="success"
                                >
                                  <AlertIcon />
                                  Arquivos
                                </Alert>
                                <Divider />
                                <Box
                                  fontSize="14px"
                                  fontWeight="500"
                                  display="flex"
                                  gridColumnGap="10px"
                                  justifyContent="space-between"
                                >
                                  <Text>
                                    Usuário:{" "}
                                    {
                                      observacao.hist_validacao_docs[0]
                                        .users_permissions_user.nome
                                    }
                                  </Text>
                                  <Text>
                                    Data:{" "}
                                    {moment(observacao.updated_at).format(
                                      "DD/MM/YYYY",
                                    )}
                                  </Text>
                                  <Text>
                                    Hora:{" "}
                                    {moment(observacao.updated_at).format(
                                      "HH:mm",
                                    )}
                                  </Text>
                                </Box>
                                <Divider />
                              </ModalHeader>
                              <ModalCloseButton />
                              <ModalBody>
                                <Grid gap={6}>
                                  <Stepper
                                    activeStep={activeStep}
                                    orientation="vertical"
                                  >
                                    <Step key="1">
                                      <StepLabel>
                                        <Text fontSize="16px">
                                          Baixar arquivos
                                        </Text>
                                      </StepLabel>
                                      <StepContent>
                                        <Grid gap={6}>
                                          <Box fontWeight="500">
                                            Competência:{" "}
                                            {observacao.mes_competencia}/
                                            {observacao.ano_competencia}
                                          </Box>

                                          {user?.fl_medico && (
                                            <FormControl>
                                              <FormLabel htmlFor="sinistralidade_01">
                                                Arquivo Analítico
                                              </FormLabel>
                                              <Input
                                                readOnly
                                                padding="10px"
                                                id="sinistralidade_01"
                                                name="sinistralidade_01"
                                                value={observacao.nm_arq_boleto}
                                              />
                                              <Button
                                                onClick={() =>
                                                  download(
                                                    observacao.hash_arq_boleto,
                                                  )
                                                }
                                                background="#cad8eb"
                                                width="100%"
                                                margin="5px auto 0"
                                                display="flex"
                                                fontSize="18px"
                                                colorScheme="unset"
                                                variant="solid"
                                                padding="0 10px"
                                                color="#555"
                                                cursor="pointer"
                                                _hover={{
                                                  backgroundColor: "#acc2e0",
                                                  color: "blue.600",
                                                }}
                                              >
                                                <MdFileDownload size="25px" />
                                                <Text
                                                  paddingBottom="2px"
                                                  marginLeft="5px"
                                                >
                                                  Baixar arquivo Analítico
                                                </Text>
                                              </Button>
                                            </FormControl>
                                          )}

                                          <FormControl>
                                            <FormLabel htmlFor="sinistralidade_02">
                                              Arquivo Sintético
                                            </FormLabel>
                                            <Input
                                              readOnly
                                              padding="10px"
                                              id="sinistralidade_02"
                                              name="sinistralidade_02"
                                              value={observacao.nm_arq_nota}
                                            />
                                            <Button
                                              onClick={() =>
                                                download(
                                                  observacao.hash_arq_nota,
                                                )
                                              }
                                              background="#cad8eb"
                                              width="100%"
                                              margin="5px auto 0"
                                              display="flex"
                                              fontSize="18px"
                                              colorScheme="unset"
                                              variant="solid"
                                              padding="0 10px"
                                              color="#555"
                                              cursor="pointer"
                                              _hover={{
                                                backgroundColor: "#acc2e0",
                                                color: "blue.600",
                                              }}
                                            >
                                              <MdFileDownload size="25px" />
                                              <Text
                                                paddingBottom="2px"
                                                marginLeft="5px"
                                              >
                                                Baixar arquivo Sintético
                                              </Text>
                                            </Button>
                                          </FormControl>
                                          <Box
                                            display="flex"
                                            gridColumnGap="10px"
                                            justifyContent="end"
                                            margin="20px 0 0"
                                          >
                                            <Button
                                              onClick={handleNext}
                                              fontWeight="500"
                                              colorScheme="orange"
                                            >
                                              Excluir
                                            </Button>
                                          </Box>
                                        </Grid>
                                      </StepContent>
                                    </Step>
                                    <Step key="2">
                                      <StepLabel>
                                        <Text fontSize="16px">Excluir</Text>
                                      </StepLabel>
                                      <StepContent>
                                        <Grid gap={6}>
                                          <FormControl
                                            isRequired
                                            isInvalid={
                                              inputObervacaoEdit &&
                                              inputObervacaoEdit.length < 1
                                            }
                                          >
                                            <FormLabel htmlFor="observacao">
                                              Observação
                                            </FormLabel>
                                            <Textarea
                                              id="observacao"
                                              name="observacao"
                                              value={inputObervacaoEdit}
                                              onChange={(e) =>
                                                setInputObservacaoEdit(
                                                  e.target.value,
                                                )
                                              }
                                            />
                                            <Text
                                              fontSize="14px"
                                              color="red.600"
                                              fontWeight="500"
                                            >
                                              * Campo obrigatório
                                            </Text>
                                          </FormControl>

                                          <Box
                                            display="flex"
                                            justifyContent="flex-end"
                                          >
                                            <Button
                                              onClick={handleBack}
                                              color="white"
                                              _hover={{
                                                backgroundColor: "gray.600",
                                              }}
                                              marginRight="10px"
                                            >
                                              Voltar
                                            </Button>
                                            <Button
                                              isLoading={isSending}
                                              width="100px"
                                              onClick={() => {
                                                excludedUtilizacao();
                                              }}
                                              disabled={
                                                inputObervacaoEdit &&
                                                inputObervacaoEdit?.length < 1
                                              }
                                              colorScheme="orange"
                                            >
                                              Excluir
                                            </Button>
                                          </Box>
                                        </Grid>
                                      </StepContent>
                                    </Step>
                                  </Stepper>
                                </Grid>
                              </ModalBody>
                              <ModalFooter></ModalFooter>
                            </>
                          ) : click &&
                            click === "downloadHist" &&
                            observacao ? (
                            <>
                              <ModalHeader>
                                <Alert
                                  padding="5px"
                                  backgroundColor="unset"
                                  status={
                                    observacao.status_documento.id === 12 ||
                                    observacao.status_documento === 12
                                      ? "success"
                                      : "warning"
                                  }
                                >
                                  <AlertIcon />
                                  Arquivos
                                </Alert>
                                <Divider />
                                <Box
                                  fontSize="14px"
                                  fontWeight="500"
                                  display="flex"
                                  gridColumnGap="10px"
                                  justifyContent="space-between"
                                >
                                  <Text>
                                    Usuário:{" "}
                                    {observacao?.users_permissions_user?.nome}
                                  </Text>
                                  <Text>
                                    Data:{" "}
                                    {moment(observacao.updated_at).format(
                                      "DD/MM/YYYY",
                                    )}
                                  </Text>
                                  <Text>
                                    Hora:{" "}
                                    {moment(observacao.updated_at).format(
                                      "HH:mm",
                                    )}
                                  </Text>
                                </Box>
                                <Divider />
                              </ModalHeader>
                              <ModalCloseButton />
                              <ModalBody>
                                <Grid gap={6}>
                                  {user?.fl_medico && (
                                    <FormControl>
                                      <FormLabel htmlFor="sinistralidade_01">
                                        Arquivo Analítico
                                      </FormLabel>
                                      <Input
                                        readOnly
                                        padding="10px"
                                        id="sinistralidade_01"
                                        name="sinistralidade_01"
                                        value={observacao.nm_arq_boleto}
                                      />
                                      <Button
                                        onClick={() =>
                                          download(observacao.hash_arq_boleto)
                                        }
                                        background="#cad8eb"
                                        width="100%"
                                        margin="5px auto 0"
                                        display="flex"
                                        fontSize="18px"
                                        colorScheme="unset"
                                        variant="solid"
                                        padding="0 10px"
                                        color="#555"
                                        cursor="pointer"
                                        _hover={{
                                          backgroundColor: "#acc2e0",
                                          color: "blue.600",
                                        }}
                                      >
                                        <MdFileDownload size="25px" />
                                        <Text
                                          paddingBottom="2px"
                                          marginLeft="5px"
                                        >
                                          Baixar arquivo Analítico
                                        </Text>
                                      </Button>
                                    </FormControl>
                                  )}

                                  <FormControl>
                                    <FormLabel htmlFor="sinistralidade_02">
                                      Arquivo Sintético
                                    </FormLabel>
                                    <Input
                                      readOnly
                                      padding="10px"
                                      id="sinistralidade_02"
                                      name="sinistralidade_02"
                                      value={observacao.nm_arq_nota}
                                    />
                                    <Button
                                      onClick={() =>
                                        download(observacao.hash_arq_nota)
                                      }
                                      background="#cad8eb"
                                      width="100%"
                                      margin="5px auto 0"
                                      display="flex"
                                      fontSize="18px"
                                      colorScheme="unset"
                                      variant="solid"
                                      padding="0 10px"
                                      color="#555"
                                      cursor="pointer"
                                      _hover={{
                                        backgroundColor: "#acc2e0",
                                        color: "blue.600",
                                      }}
                                    >
                                      <MdFileDownload size="25px" />
                                      <Text
                                        paddingBottom="2px"
                                        marginLeft="5px"
                                      >
                                        Baixar arquivo Sintético
                                      </Text>
                                    </Button>
                                  </FormControl>
                                </Grid>
                              </ModalBody>
                              <ModalFooter></ModalFooter>
                            </>
                          ) : (
                            click &&
                            click === "observacao" &&
                            observacao && (
                              <>
                                <ModalHeader>
                                  <Alert
                                    padding="5px"
                                    backgroundColor="unset"
                                    status={"warning"}
                                  >
                                    <AlertIcon />
                                    Arquivos excluídos. <br />
                                    Aguardando reenvio
                                  </Alert>
                                  <Divider />
                                  <Box
                                    fontSize="14px"
                                    fontWeight="500"
                                    display="flex"
                                    gridColumnGap="20px"
                                    justifyContent="space-between"
                                  >
                                    <Text>
                                      Usuário:{" "}
                                      {observacao.users_permissions_user.nome}
                                    </Text>
                                    <Text>
                                      Data:{" "}
                                      {moment(observacao.updated_at).format(
                                        "DD/MM/YYYY",
                                      )}
                                    </Text>
                                    <Text>
                                      Hora:{" "}
                                      {moment(observacao.updated_at).format(
                                        "HH:mm",
                                      )}
                                    </Text>
                                  </Box>
                                  <Divider />
                                </ModalHeader>
                                <ModalCloseButton />
                                <ModalBody>
                                  <Text
                                    backgroundColor="#f2f2f2"
                                    textAlign="center"
                                    fontSize="18px"
                                    padding="20px 10px"
                                    marginBottom="15px"
                                  >
                                    {observacao.observacao}
                                  </Text>
                                </ModalBody>
                              </>
                            )
                          )}
                        </ModalContent>
                      </Modal>
                    </>
                  )}
                </>
              ) : (
                selectedContract &&
                select &&
                !pageLoading && (
                  <Alert
                    status="info"
                    fontSize="18px"
                    marginTop={mobile ? "40px" : 0}
                    fontWeight="500"
                  >
                    {vigenciaContratoAtivo ? (
                      <>
                        <AlertIcon />A primeira competência será disponibilizada
                        em {vigenciaContrato}.
                      </>
                    ) : (
                      <>
                        <AlertIcon />
                        Contrato encerrado antes da primeira competência ser
                        disponibilizada.
                      </>
                    )}
                  </Alert>
                )
              )}
            </>
          )}
        </Box>
      </>
    )
  );
};

export default Utilizacao;
